<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="1.500em"
  height="1.500em"
  aria-hidden="true"
  focusable="false"
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10 3H3v18h7V3zm11 0h-7v18h7V3z"
  /></svg
>
